import React, { useRef, useState, useEffect } from 'react';
import { useFrame, useLoader } from '@react-three/fiber';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import { Html } from '@react-three/drei';
import { useStorefront3DStore } from '../../store/useStorefront3DStore';

const GeneratedModel = ({ model, position = [0, 0, 0] }) => {
  const meshRef = useRef();
  const [hovered, setHovered] = useState(false);
  const [error, setError] = useState(null);
  const { viewerSettings } = useStorefront3DStore();

  // Load GLB model
  const gltf = useLoader(GLTFLoader, model.url, (loader) => {
    loader.setPath('');
  }, (error) => {
    console.error('Failed to load GLB model:', error);
    setError('Failed to load 3D model');
  });

  // Simple hover animation
  useFrame((state) => {
    if (meshRef.current && hovered) {
      meshRef.current.rotation.y = Math.sin(state.clock.elapsedTime * 2) * 0.1;
    }
  });

  const handleClick = () => {
    console.log('Generated model clicked:', model.name);
  };

  if (error) {
    return (
      <group position={position}>
        <mesh>
          <boxGeometry args={[1, 1, 1]} />
          <meshStandardMaterial color="#ff6b6b" />
        </mesh>
        <Html position={[0, 1.5, 0]} center>
          <div style={{
            background: 'rgba(255, 0, 0, 0.8)',
            color: 'white',
            padding: '4px 8px',
            borderRadius: '4px',
            fontSize: '12px',
            whiteSpace: 'nowrap'
          }}>
            Error loading model
          </div>
        </Html>
      </group>
    );
  }

  return (
    <group position={position}>
      <primitive
        ref={meshRef}
        object={gltf.scene.clone()}
        scale={model.scale || [1, 1, 1]}
        rotation={model.rotation || [0, 0, 0]}
        onClick={handleClick}
        onPointerOver={() => setHovered(true)}
        onPointerOut={() => setHovered(false)}
      />

      {/* Model Label */}
      {viewerSettings.showLabels && (
        <Html
          position={[0, 2, 0]}
          center
          distanceFactor={10}
          occlude
        >
          <div
            style={{
              background: 'rgba(76, 175, 80, 0.9)',
              color: 'white',
              padding: '4px 8px',
              borderRadius: '4px',
              fontSize: `${(viewerSettings.labelSize || 1) * 12}px`,
              whiteSpace: 'nowrap',
              pointerEvents: 'none',
              transform: 'translate(-50%, -100%)',
              border: '1px solid rgba(255, 255, 255, 0.3)'
            }}
          >
            {model.name}
            <div style={{ fontSize: '10px', opacity: 0.8 }}>
              Generated Model
            </div>
          </div>
        </Html>
      )}
    </group>
  );
};

export default GeneratedModel;
